import secondaryComponents from "../../../../components/secondaryComponents";
import primaryComponents from "../../../../components/primaryComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useGetChartAccountTransactionDetails } from "../../../../hooks/api/queries";

const ChartAccountTransactionDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    data: chartAccountTransactionDetails,
    isFetching: isFetchingChartAccountTransactionDetails,
  } = useGetChartAccountTransactionDetails(id, {
    enabled: !!id,
  });
  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Journal Entry Details"
      description="View journal entry details"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.3 } }}
          exit={{ opacity: 0 }}
        >
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <primaryComponents.Button
              classNames="btn btn--outline"
              onClick={() => navigate(-1)}
            >
              <FontAwesomeIcon
                icon="angle-left"
                className="mr-3"
                style={{ fontSize: "18px" }}
              />
              <span>Back</span>
            </primaryComponents.Button>
            <h4 className="font-weight-semibold mb-0">
              TRX ID - {chartAccountTransactionDetails?.data?.id}
            </h4>
          </div>

          <secondaryComponents.LoaderHelper
            classNames="mt-5"
            isLoading={isFetchingChartAccountTransactionDetails}
          >
            <secondaryComponents.ChartAccountTransactionDetails
              chartAccountTransactionDetails={
                chartAccountTransactionDetails?.data
              }
            />
          </secondaryComponents.LoaderHelper>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default ChartAccountTransactionDetails;
